import { create } from 'zustand';
export const heroSlidesData = [
    {
        title: 'Beyond the Horizon',
        subtitle: 'Luxury yacht charters, matched to your dreams.',
        image: '/assets/images/hero/Charter_1.jpg',
        mobile: '/assets/images/hero/Charter_1.jpg',
        alt: 'Luxury travel destination showcasing excellence',
    },
    {
        title: 'Freedom, Found',
        subtitle: 'Handpicked yachts. Unmatched experiences.',
        image: '/assets/images/hero/Charter_2.jpg',
        mobile: '/assets/images/hero/Charter_2.jpg',
        alt: 'Exciting travel adventures off the beaten path',
    },
    {
        title: 'Set Sail in Style',
        subtitle: "Explore the world's finest yachts in one place.",
        image: '/assets/images/hero/Charter_3.jpg',
        mobile: '/assets/images/hero/Charter_3.jpg',
        alt: 'Peaceful travel location for relaxation',
    },
    {
        title: 'Escape Ordinary Waters',
        subtitle: 'Discover your perfect charter, wherever you roam.',
        image: '/assets/images/hero/Charter_4.jpg',
        mobile: '/assets/images/hero/Charter_4.jpg',
        alt: 'Serene and tranquil getaway setting',
    },
    {
        title: 'Luxury That Moves',
        subtitle: 'Yachts curated for every voyage, every vision.',
        image: '/assets/images/hero/Charter_5.jpg',
        mobile: '/assets/images/hero/Charter_5.jpg',
        alt: 'Rare and unique travel journey',
    }
];